export default function Total({form, ownLocations}) {

    const calcPrice = () => {
        console.log('---')
        console.log(form?.extraPrice)
        console.log(form?.extraPriceAtt)
        console.log(form?.attendants ?? 0)
        let attendants = parseInt(form?.attendants ?? 0);
        let dealPrice = parseInt(form?.dealPrice ?? 0);
        let extraPrice = parseInt(form?.extraPrice?.filter(function (item) {
            if (parseInt(item) <= 0) {
                return false; // skip
            }
            return true;
        })?.reduce((partialSum, a) => partialSum + a, 0) ?? 0);
        let extraPriceAtt = parseInt(form?.extraPriceAtt?.filter(function (item) {
            if (parseInt(item) <= 0) {
                return false; // skip
            }
            return true;
        })?.reduce((partialSum2, a) => partialSum2 + (attendants * a), 0) ?? 0);

        // ensure to 0 if minus
        if (attendants < 0) attendants = 0;
        if (dealPrice < 0) dealPrice = 0;
        if (extraPrice < 0) extraPrice = 0;
        if (extraPriceAtt < 0) extraPriceAtt = 0;

        let locationPrice = 0;
        //if (form.location === 'pieStudio') {
        //    locationPrice = attendants * -10;
        //}

        if (form.location === 'ownLocation') {
            if (form?.zip) {
                const result = ownLocations.find(element => element.zip === (form?.zip.toString()).slice(0, 2));

                locationPrice = attendants * (result?.price ? parseInt(result?.price) : 0);
            }
        }

        let total = (attendants * dealPrice) + extraPrice + extraPriceAtt + locationPrice;

        return total > 0 ? total : 0;
    }

    return (
        <>
            <div className={'total_container'}>
                {calcPrice()} CHF
            </div>
        </>
    );
}

